import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {I18n, Translate} from 'react-redux-i18n';

import { MenuItem } from '@blueprintjs/core';
import { Select, MultiSelect } from '@blueprintjs/select';

import style from './ExerciseRun.module.css';

import {
  sendMessage as sendMessageAction,
  changeInput as changeInputAction,
  selectUser as selectUserAction,
  deselectUser as deselectUserAction,
  deselectAllUsers as deselectAllUsersAction,
} from './CommunicationBoxActions';

import { cleanLog as cleanLogAction } from '../Logger/LoggerActions';
import helpers from '../../helpers';

class CommunicationBox extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      userFilter: '',
      audioFiles: [],
      selectedAudioFileIndex: -1,
    }

    this._sendMessage = this._sendMessage.bind(this);
    this._selectUser = this._selectUser.bind(this);
    this._deselectUser = this._deselectUser.bind(this);
    this._deselectAllUsers = this._deselectAllUsers.bind(this);
    this._sendAudio = this._sendAudio.bind(this);
    this._onAudioSelected = this._onAudioSelected.bind(this);
    this._changeInput = this._changeInput.bind(this);
    this.props.cleanLog();
  }

  componentDidUpdate(prevProps) {
    if (this.props.messages.length > prevProps.messages.length) {
      this.textArea.scrollTop = this.textArea.scrollHeight;
    }
  }

  _selectUser(id) {
    this.props.selectUser(id);
  }
  
  _deselectUser(id) {
    this.props.deselectUser(id);
  }
  
  _deselectAllUsers() {
    this.props.deselectAllUsers();
  }
  
  _selectAudio() {
    window.document.getElementById("combox-audio-select").click();
  }
  
  _onAudioSelected(e) {
    if(e.target.files.length === 0) return;
    console.log("Audio selected");
    
    // getting a hold of the file reference
    const file = e.target.files[0]; 
      
    this.setState((prevState) => ({ audioFiles: prevState.audioFiles.concat(file) }))
    // this._sendAudio(file);
  }
  
  _sendAudio() {
    const file = this.state.audioFiles[this.state.selectedAudioFileIndex];
    // setting up the reader
    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = readerEvent => {
      const content = readerEvent.target.result;
      console.log("Content type:", typeof content)
      const { sendMessage, selected } = this.props;
      sendMessage(selected, content, { contentType: 'audio' });
      const fileEl = document.getElementById("combox-audio-select");
      fileEl.value = fileEl.defaultValue;
    }
  }

  _changeInput(e) {
    this.props.changeInput(e.target.value);
  }

  _sendMessage() {
    const { sendMessage, selected, textinput } = this.props;

    sendMessage(selected, textinput);
  }

  render() {
    const { messages, exercise, selected, textinput } = this.props;


    const currentUser = helpers.getUserFromLocalStorage();
    let users = (exercise && exercise.users) || [];
    users = users.filter(user => user.id !== currentUser._id);

    return (
      <div>
        <h4 className={style.title}><strong>
          <Translate value="exerciseRun.ComChat"/>
          </strong></h4>
        <div className="row">
          <div className="col-sm-3">
            {/*<select
              value={selected}
              onChange={this._selectUser}
              className={`${style.select}`}
            >
              <option value="">{ I18n.t('controls.all') }</option>
              {
                users.map(user => (
                  <option
                    value={user.id}
                    key={user.id}
                  >
                    {user.name}
                  </option>
                ))
              }
            </select>*/}
            <MultiSelect
              items={users.filter((user) => !selected.includes(user.id))}
              itemRenderer={(user, {modifiers, handleClick})=>(
                  <MenuItem
                      active={modifiers.active}
                      onClick={handleClick}
                      key={user.id}
                      text={user.name}
                      shouldDismissPopover={false}
                  />
              )}
              tagRenderer={(user)=>user?.name}
              selectedItems={selected && selected.map((entry) => users.find((user) => user.id === entry))}
              onItemSelect={(user)=>{
                  this._selectUser(user.id)
              }}
              itemsEqual={(a,b)=>a.id === b.id}
              tagInputProps={{
                  onRemove: (tag, index)=>{
                    this._deselectUser(selected[index])
                  }
              }}
              placeholder="All"
              // onChange={(event)=>this.setState({userFilter: event.target.value})}
              // onKeyDown={(event)=>event.preventDefault()}
            />
          </div>
          <div className="col-sm-2">
            <select value={this.state.selectedAudioFileIndex} onChange={(e) => this.setState({ selectedAudioFileIndex: e.target.value })} style={{width: '90%', height: '100%', borderRadius: 5}}>
              <option value={-1} style={{ color: '#eee' }}>No Audio</option>
              {
                this.state.audioFiles.map((f, index) => {
                  return (
                    <option value={index}>{f.name}</option>
                  )
                })
              }
            </select>
          </div>
          <div className="col-sm-1">
            <button className="btn btn-primary" onClick={this._selectAudio}>Audio</button>
            <input type="file" accept=".mp3,.wav,.aac,.ogg" id="combox-audio-select" onChange={this._onAudioSelected} style={{ display: 'none' }} />
          </div>
          <div className="col-sm-1">
            <button className="btn btn-primary" onClick={this._deselectAllUsers}>Clear</button>
          </div>
          <div className="col-sm-7">
            <input
              type="text"
              className={style.communicationInput}
              value={textinput}
              onChange={this._changeInput}
              onKeyDown={(e)=>{
                if(e.key === 'Enter') {
                  this._sendMessage()
                }
              }}
              disabled={this.state.selectedAudioFileIndex != -1}
            />
          </div>
          <div className="col-sm-2">
            <button
              className={`btn btn-primary ${style.communicationInput}`}
              onClick={() => this.state.selectedAudioFileIndex === -1 ? this._sendMessage() : this._sendAudio()}
            >
              <i className="fas fa-play" />
            </button>
          </div>
        </div>
        <br/>
        <textarea
          rows="10"
          className={style.textarea}
          value={messages.join('\n')}
          ref={(elm) => { this.textArea = elm; }}
          readOnly
        />
      </div>
    );
  }
}

CommunicationBox.propTypes = {
  exercise: PropTypes.object,
  messages: PropTypes.array,
  selected: PropTypes.array,
  textinput: PropTypes.string,
  sendMessage: PropTypes.func,
  selectUser: PropTypes.func,
  changeInput: PropTypes.func,
  cleanLog: PropTypes.func,
};

const mapStateToProps = state => ({
  exercise: state.exercise.exercise,
  messages: state.logger.messages,
  selected: state.communicationbox.selected,
  textinput: state.communicationbox.input,
});


const mapDispatchToProps = {
  sendMessage: sendMessageAction,
  selectUser: selectUserAction,
  deselectUser: deselectUserAction,
  deselectAllUsers: deselectAllUsersAction,
  changeInput: changeInputAction,
  cleanLog: cleanLogAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunicationBox);

